import { Component, Input, OnInit } from '@angular/core';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CertificatenoFloatPointService } from 'src/app/Service/CertificatenoFloatPoint/CertificatenoFloatPoint.service';

@Component({
  selector: 'app-CertificateFormFloatPoint',
  templateUrl: './CertificateFormFloatPoint.component.html',
  styleUrls: ['./CertificateFormFloatPoint.component.scss']
})
export class CertificateFormFloatPointComponent implements OnInit {

  @Input() inner_Certificate: General_Interface = Empty_General_Interface()
  Token: string = ""
  Procssing:boolean=false

  constructor(
    private Alertify_Service:AlertifyService,
    private CertificatenoFloatPoint_Service:CertificatenoFloatPointService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Read_CertificatenoFloatPoint()
  }

  CertificatenoFloatPoint_DataList:Array<General_Interface>=[]
  Read_CertificatenoFloatPoint() {
    this.Procssing = true
    this.CertificatenoFloatPoint_Service.GetRecord(this.Token, this.inner_Certificate.id).subscribe(
      data => {
        this.CertificatenoFloatPoint_DataList = data
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  Submit() {
    this.Procssing = true
    this.CertificatenoFloatPoint_Service.Submit(this.CertificatenoFloatPoint_DataList,this.inner_Certificate.id, this.Token).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("The information was registered successfully")
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

}
